/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import { client, withUnwrap } from '../.kubb/client'
import type { AuthSupportStopOptions, AuthSupportStopResponses } from '../models/AuthSupportStop'
import { authSupportStopResponseSchema } from '../schemas/authSupportStopSchema'

/**
 * @summary End the support session: revoke the support refresh token and RETURN TO THE ACTING ADMIN's own
 * session (re-minted from the act_as claim) — same response shape as login. Outside a support
 * session it just revokes + clears the cookie (legacy behavior).
 * {@link /api/v4/auth/support/stop}
 */
export function authSupportStop<ThrowOnError extends boolean = true>(
  options: Options<AuthSupportStopOptions, ThrowOnError> = {}
): Unwrappable<RequestResult<AuthSupportStopResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/api/v4/auth/support/stop',
      security: [{ type: 'http', scheme: 'bearer' }],
      validator: { response: authSupportStopResponseSchema },
      ...config,
    }) as Promise<RequestResult<AuthSupportStopResponses, ThrowOnError>>
  )
}
